export default [
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('./Invoices.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'invoice',
    },
  },
]
